import { render, staticRenderFns } from "./SGPTimelineHistoricoComponent.vue?vue&type=template&id=54922e3f"
import script from "./SGPTimelineHistoricoComponent.vue?vue&type=script&lang=js"
export * from "./SGPTimelineHistoricoComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPTimelineHistoricoComponent.vue?vue&type=style&index=0&id=54922e3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports